import React from "react";
//#region types
import { LinkifyProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
//#endregion
import cssExports from "theme/styles/main.module.scss";

const regex = /(https?:\/\/[^\s]+)/g;

const Linkify: React.FC<LinkifyProps> = (props) => {
  const { message } = props;

  const messageParts = message.split(regex);

  return (
    <pre>
      {messageParts.map((part) => (
        <React.Fragment key={part}>
          {part.match(regex) ? (
            <a href={part} target="_blank" className={cssExports.linkText} rel="noreferrer">
              {part}
            </a>
          ) : (
            part
          )}
        </React.Fragment>
      ))}
    </pre>
  );
};

export default Linkify;
